import type { Path } from "react-hook-form";
import type { FormValues } from "types/form.types";

export const TOOL_INFO_FIELDS = {
  serviceTool: "service_tool",
  serviceType: "service_type",
} as const satisfies Record<string, Path<FormValues>>;

export const INPUT_FIELD_NAMES = {
  // Contact info
  phoneNumber: "phone.number",
  phoneDialCode: "phone.dialCode",
  firstName: "first_name",
  lastName: "last_name",
  companyName: "company_name",
  email: "email",
  message: "message",

  // Web access
  webAccessShipmentsPerMonth: "webAccess.shipmentsPerMonth",
  webAccessDevices: "webAccess.devices",
  webAccessLicences: "webAccess.license_count",

  // App integration
  webIntegrationSearchesPerMonth: "webIntegration.monthly_calls",
  webIntegrationSubAccounts: "webIntegration.subAccounts",
  webIntegrationPerDay: "webIntegration.freePerDay",
  webIntegrationDevices: "webIntegration.devices",
  webIntegrationLicences: "webIntegration.license_count",

  // API
  apiPerMonth: "api.monthly_calls",
  apiActions: "api.actions",

  // Transit time
  transitTimeMonthlyCalls: "transitTime.monthly_calls",
  transitTimeTransportTypes: "transitTime.transport_types",
  // transitTimeTransportModes: "transitTime.transportModes",
  // transitTimeCalculationsPerMonth: "transitTime.calculationsPerMonth",
  transitTimeLicences: "transitTime.license_count",

  // Vessel schedules
  vesselSchedulessearch_modes: "vesselSchedules.search_modes",
  vesselSchedulesSearchesPerMonth: "vesselSchedules.monthly_calls",
  vesselSchedulesLicences: "vesselSchedules.license_count",

  // Container tracking
  containerTrackingrequest_types: "containerTracking.request_types",
  containerTrackingmonthly_shipments: "containerTracking.monthly_shipments",
  containerTrackingSearchesPerMonth: "containerTracking.monthly_calls",
  containerTrackingApiCallsPerMonth: "containerTracking.monthly_calls",
  containerTrackingLicences: "containerTracking.license_count",

  // Air tracking
  airTrackingrequest_types: "airTracking.request_types",
  airTrackingmonthly_shipments: "airTracking.monthly_shipments",
  airTrackingSearchesPerMonth: "airTracking.monthly_calls",
  airTrackingApiCallsPerMonth: "airTracking.monthly_calls",
  airTrackingLicences: "airTracking.license_count",

  // Carbon emissions
  carbonEmissionsShippingTypes: "carbonEmissions.shipping_types",
  carbonEmissionsTypeOfCalculation: "carbonEmissions.calculation_types",
  carbonEmissionsCalculationsPerMonth: "carbonEmissions.calculationsPerMonth",
  carbonEmissionsLicences: "carbonEmissions.license_count",
  carbonEmissionsApiCallsPerMonth: "carbonEmissions.apiCallsPerMonth",

  // Cargo load optimizer
  cargoLoadOptimizerLicences: "cargoLoadOptimizer.license_count",
} as const satisfies Record<string, Path<FormValues>>;
